export default {
    beforeRouteUpdate (to, from , next) {
        if ( ! this.isDirty() || window.confirm(window.App.$t('misc.confirm_page_leave'))) {
            window.onbeforeunload = null;
            next();
        } else {
            next(false);
        }
    },

    beforeRouteLeave (to, from , next) {
        if ( ! this.isDirty() || window.confirm(window.App.$t('misc.confirm_page_leave'))) {
            window.onbeforeunload = null;
            next();
        } else {
            next(false);
        }
    }
}